/* PRODUÇÃO */

export const environment = {
  apiUrl: 'https://portalapi.sendfy.io/api',
  newApiUrl: 'https://awsapi.sendfy.io',
  sendMessageUrl: 'https://apiwhatsapp.sendfy.io/v1',
  version: '3.42.0',
  production: true,
  recaptchaKey: '6LfqkPoUAAAAAEYcGDv4L2qf3F7K3hVhcJT0Fb0-',
  facebookAppId: '463554841960589'
};

/*

COMANDO PARA DEPLOY:
ng build --prod

*/
